import { render, staticRenderFns } from "./KnSupplierSubcategories.vue?vue&type=template&id=ba00ddf0&"
import script from "./KnSupplierSubcategories.vue?vue&type=script&lang=js&"
export * from "./KnSupplierSubcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports